import OurServicesComponent from '../components/ourServicesComponent';
import  { useState } from 'react';
import ContactForm from '../components/ContactoForm/ContactoForm';
import WhoAreWeTxt from '../components/whoAreWeTxt';
// import app css
import './home.css';


const Home = () => {
    const [showContact, setShowContact] = useState(false);


    return (
        <div className='home-container' style={{ 
            width: '100vw', 
            minHeight: '100vh', 
            padding: '5rem', 
            display: 'flex', 
            flexDirection: 'column', 
            alignItems: 'flex-start',
            justifyContent: 'center',
            textAlign: 'left',
            position: 'relative',
            overflow: 'hidden',
            backgroundColor: 'beige'
        }}>
            <div className='relleno'> 
            <div
                id='textContainer'
                style={{
                    position: 'relative',
                    zIndex: 1,
                    display: 'flex',
                    alignItems: 'flex-start',
                    flexDirection: 'column',
                    justifyContent: 'flex-start',
                    gap: '0.5rem',
                    left: '10%',
                }}
            >
                <p id='subtitle'
                    style={{
                        color: "#0000FF",
                        fontSize: "1.5rem",
                        marginBottom: '-4rem',
                        marginTop: '6rem',
                        marginLeft: '-90px',
                        letterSpacing: '4px' // <-- más separación entre letras
                    }}
                >
                    Digital marketing agency
                </p>
                <h1
                    id='main-title'
                    style={{
                        color: "#0000FF",
                        fontWeight: "bold",
                        fontSize: "7rem",
                        fontFamily: "'Montserrat', 'Segoe UI', 'Arial', sans-serif",
                        letterSpacing: "2px",
                        width: '100%',
                        height: '100vh',
                        fontStretch: 'expanded',
                        transform: 'scaleX(1.3)'
                    }}
                >
                    Creativity that
                    <br />
                    connects.
                </h1>
            </div>
             </div>
            <div className='subtitleContainer' style={{ position: 'relative', zIndex: 1, marginTop: '2rem' }}>
            <WhoAreWeTxt id='whoAreWe' />
            </div>
            <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                <button
                    id='contactButton'
                    style={{
                        position: 'relative',
                        zIndex: 2,
                        marginTop: '5rem',
                        padding: '1rem 2rem',
                        fontSize: '1.5rem',
                        fontWeight: 'bold',
                        letterSpacing: '1px',
                        textTransform: 'uppercase',
                        fontFamily: "'Montserrat', 'Segoe UI', 'Arial', sans-serif",
                        color: '#fff',
                        background:'#ed4e01',
                        border: 'none',
                        borderRadius: '8px',
                        cursor: 'pointer'
                    }}
                    onClick={() => setShowContact(prev => !prev)}
                >
                    Contact Us
                </button>
            </div>
            {showContact && (
                // Full-screen centered overlay for the form
                <div
                    style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100vw',
                        height: '100vh',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        zIndex: 9999,
                        background: 'rgba(0,0,0,0.45)'
                    }}
                    onClick={() => setShowContact(false)} // click outside to close
                >
                    <div
                        style={{
                            width: 'calc(100% - 2rem)',
                            maxWidth: '900px',
                            background: '#fff',
                            borderRadius: '10px',
                            padding: '1.5rem',
                            boxShadow: '0 10px 30px rgba(0,0,0,0.2)',
                        }}
                        onClick={(e) => e.stopPropagation()} // prevent closing when clicking inside
                    >
                        <ContactForm />
                    </div>
                </div>
            )}
            <div style={{ position: 'relative', zIndex: 1, marginTop: '2rem' }}>
                <OurServicesComponent />
            </div>
        </div>
    );
};

export default Home;